import format from 'date-fns/format';

export function calculateDateIntervalOverlap(
  verticalMin: string | undefined,
  verticalMax: string | undefined,
  apiMin: string | undefined,
  apiMax: string | undefined,
): { minDate: string | undefined; maxDate: string | undefined; hasOverlap: boolean } {
  if (!verticalMin && !verticalMax && !apiMin && !apiMax) {
    return { minDate: undefined, maxDate: undefined, hasOverlap: true };
  }

  let finalMin: string | undefined;
  if (verticalMin && apiMin) {
    finalMin = verticalMin > apiMin ? verticalMin : apiMin;
  } else {
    finalMin = verticalMin || apiMin;
  }

  let finalMax: string | undefined;
  if (verticalMax && apiMax) {
    finalMax = verticalMax < apiMax ? verticalMax : apiMax;
  } else {
    finalMax = verticalMax || apiMax;
  }

  const hasOverlap = finalMin && finalMax ? finalMin <= finalMax : true;

  return {
    minDate: finalMin,
    maxDate: finalMax,
    hasOverlap,
  };
}

export function calculateInitialStartDate(
  minDate: string | undefined,
  maxDate: string | undefined,
): string | undefined {
  const today = getTodayDateString();

  if (maxDate && maxDate < today) {
    return undefined;
  }

  if (minDate && minDate > today) {
    return minDate;
  }

  return today;
}

export function getTodayDateString(): string {
  const today = new Date();
  return today.toISOString().split('T')[0];
}

export function isToday(date: Date): boolean {
  const today = new Date();
  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
}

export function isStartDateValid(dateString: string | null): boolean {
  if (!dateString) {
    return false;
  }

  const date = new Date(dateString);
  if (date < new Date()) {
    return false;
  }

  if (isToday(date)) {
    return false;
  }

  return true;
}

export function isDateInRange(date: Date, min: string | undefined, max: string | undefined): boolean {
  const dateString = format(date, 'yyyy-MM-dd');

  if (min && dateString < min) {
    return false;
  }

  if (max && dateString > max) {
    return false;
  }

  return true;
}
